import { useParams } from 'react-router-dom';
import { useUpdateRecommendation } from '@features/programs/index.ts';
import VideoProgram from '@src/library/components/programs/VideoProgram/index.ts';

type PT = {};
export const RecommendedProgramPage = ({}: PT) => {
  const { hash } = useParams();
  const { program, closeProgram, message, isError } = useUpdateRecommendation(hash as string);

  // if (isLoading) {
  //   return <Loader />;
  // }
  if (isError) {
    return `SOME ERROR HAS OCCURED`;
  }
  // console.log("program: ", program);

  if (program) {
    return <VideoProgram program={program} onClose={closeProgram} />;
  }
  if (message) {
    if (message === 'Program already recommended') {
      return 'Программа уже рекомендована';
    }
  }
};
